import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";
import StudyGroupsList from "../../../components/Admin/StudyGroups/List/StudyGroupsList";
import Toolbar from "components/Admin/StudyGroups/Toolbar";
import { clearStudyGroups } from "../../../actions/studygroups";

const { getStudygroupsAdmin, showDeleteStudygroupsConfirmationModal } = actions;

class StudyGroupsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studygroup_ids: [],
      page: props.page || 1,
      query: {
        ...props.query,
      },
    };
  }

  componentDidMount() {
    this.loadStudyGroups();
  }

  componentWillUnmount() {
    this.props.clearStudyGroups();
  }

  deleteStudygroups = () => {
    if (this.state.studygroup_ids.length > 0) {
      this.props.deleteStudygroups(this.state.studygroup_ids);
    }
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.loadStudyGroups
    );
  };

  checkedStudygroupIds = (studygroup_id) => {
    var ids = _.assign(this.state.studygroup_ids);
    const index = this.state.studygroup_ids.indexOf(studygroup_id);

    if (index === -1) {
      ids.push(studygroup_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ studygroup_ids: ids });
  };

  loadStudyGroups = () =>
    this.props.loadStudygroups(this.state.query, this.state.page);

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadStudyGroups, timeout);
    });
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order,
      },
    };
    this.changeQuery(query, 0);
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.setState({ page: 1 }, () => {
      this.changeQuery(query);
    });
  };

  render() {
    const {
      deleteStudygroups,
      state,
      onChangeQuery,
      // onDateRangeChange
    } = this;
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_sponsor"></div>
        <Toolbar
          filterProps={{
            ...state,
            // onDateRangeChange,
            onChangeQuery,
          }}
          toolsProps={{
            count: this.props.count,
            deleteStudygroups,
          }}
        />
        <div className="admin_sponsors_table admin_table">
          <StudyGroupsList
            studygroups={this.props.studygroups}
            checkedStudygroupIds={this.checkedStudygroupIds}
            studygroup_ids={this.state.studygroup_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroups: state.studygroups.studygroups.values,
  query: state.studygroups.studygroups.query,
  page: state.studygroups.studygroups.page,
  total_pages: state.studygroups.studygroups.total_pages,
  count: state.studygroups.studygroups.count,
});

const mapDispatchToProps = (dispatch) => ({
  deleteStudygroups: (studygroup_ids) =>
    dispatch(showDeleteStudygroupsConfirmationModal(studygroup_ids)),
  loadStudygroups: (page, query) => dispatch(getStudygroupsAdmin(page, query)),
  clearStudyGroups: () => dispatch(clearStudyGroups()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupsComponent);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/StudyGroups.jsx